import ShopSupplierListResultModelBase from '../_generated/modelBases/shop-supplier-list-result-model-base';

export default class ShopSupplierListResultModel extends ShopSupplierListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
